var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",staticClass:"frame"},[_c('div',{staticClass:"frame__content"},[_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }